import React from "react";
// import { useParams } from "react-router-dom";


const FinancialStatement = ()=>{
    const SSOURL = process.env.REACT_APP_SSOURL;
    return(
        <iframe src={`${SSOURL}/apps/finance/statements`} style={{ width: "100%", height: "85vh",border:"none",paddingBottom:"5vh" }} title="Dynamic Content"></iframe>
    )
}

export default FinancialStatement;